// extracted by mini-css-extract-plugin
export default {"advertTab":"ZJxakFM2"};